
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/planos",
      function () {
        return require("private-next-pages/planos/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/planos"])
      });
    }
  